import { render, staticRenderFns } from "./DoseActes.vue?vue&type=template&id=3e3b3224&"
import script from "./DoseActes.vue?vue&type=script&lang=js&"
export * from "./DoseActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports